import script from "./mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile.vue?vue&type=script&setup=true&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=428cc2b4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428cc2b4"]])

export default __exports__